<template>
  <div :class="'col-md-' + col" class="datapicker-range" :style="{'padding': paddingNull ? '0' : ''}">
    <label>{{ label }} <span v-if="isRequired">*</span></label>
    <input type="text" class="datepicker-style" :id="'datepickerInitEnd' + variableName" readonly>
    <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg"
         :style="{'left': paddingNull ? '12px' : ''}">
      <path
        d="M19 4H18V2H16V4H8V2H6V4H5C4.46957 4 3.96086 4.21071 3.58579 4.58579C3.21071 4.96086 3 5.46957 3 6V20C3 20.5304 3.21071 21.0391 3.58579 21.4142C3.96086 21.7893 4.46957 22 5 22H19C19.5304 22 20.0391 21.7893 20.4142 21.4142C20.7893 21.0391 21 20.5304 21 20V6C21 5.46957 20.7893 4.96086 20.4142 4.58579C20.0391 4.21071 19.5304 4 19 4ZM19 20H5V10H19V20ZM19 8H5V6H19V8Z"
        fill="#7F8897"/>
    </svg>
  </div>
</template>

<script>
import moment from 'moment'

export default {
  name: "datapickerGlobal",
  props: {
    paddingNull: {
      default: false
    },
    col: '',
    label: {
      required: true
    },
    isRequired: {
      default: false
    },
    rangeDaysInit: {
      required: true
    },
    haveRangeDaysMax: {
      required: true
    },
    variableName: {
      default: ''
    },
    //se o haveRangeDaysMax for true, passar a quantidade de dias na prop abaixo 'rangeDaysMax'
    rangeDaysMax: ''
  },
  data() {
    return {
      dateValue: '',
      initDate: '',
      endDate: '',
      initDateVar: '',
      endDateVar: '',
    }
  },
  methods: {},
  mounted() {
    const date = new Date();
    this.initDate = moment(date).subtract(this.rangeDaysInit, 'days').format('DD/MM/YYYY');
    this.endDate = moment(date).format('DD/MM/YYYY');
    this.$route.params[this.variableName + 'Init'] = moment(date).subtract(this.rangeDaysInit, 'days').format('YYYY-MM-DD');
    this.$route.params[this.variableName + 'End'] = moment(date).format('YYYY-MM-DD');
    this.initDateVar = moment(date).subtract(this.rangeDaysInit, 'days').format('YYYY-MM-DD');
    this.endDateVar = moment(date).format('YYYY-MM-DD');

    let haveRange = ''

    if (this.haveRangeDaysMax == 'true') {
      haveRange = {
        "days": this.rangeDaysMax
      }
    }

    $('#datepickerInitEnd' + this.variableName).daterangepicker({
      maxSpan: haveRange,
      startDate: this.initDate,
      endDate: this.endDate,
      alwaysShowCalendars: true,
      showDropdowns: true,
      locale: {
        format: "DD/MM/YYYY",
        separator: " - ",
        applyLabel: "Aplicar",
        cancelLabel: "Cancelar",
        fromLabel: "De:",
        toLabel: "Para:",
        customRangeLabel: "Personalizados",
        weekLabel: "Semana",
        daysOfWeek: [
          "Dom",
          "Seg",
          "Ter",
          "Qua",
          "Qui",
          "Sex",
          "Sáb"
        ],
        monthNames: [
          "Janeiro",
          "Fevereiro",
          "Março",
          "Abril",
          "Maio",
          "Junho",
          "Julho",
          "Agosto",
          "Setembro",
          "Outubro",
          "Novembro",
          "Dezembro"
        ],
        firstDay: 1
      },
      ranges: {
        'Ultimos 7 dias': [moment().subtract(6, 'days'), moment()],
        'Ultimos 30 dias': [moment().subtract(29, 'days'), moment()],
        'Todos': [moment('2022-02-14'), moment()],
      },
    }, (init, end) => {
      this.initDate = moment(init._d).format('YYYY-MM-DD')
      this.endDate = moment(end._d).format('YYYY-MM-DD')

      this.$route.params[this.variableName + 'Init'] = this.initDate
      this.$route.params[this.variableName + 'End'] = this.endDate

      this.initDateVar = this.initDate
      this.endDateVar = this.endDate
    });
  },
  watch: {
    initDateVar(newValue, oldValue) {
      this.$emit('initDate', newValue)
    },
    endDateVar(newValue, oldValue) {
      this.$emit('endDate', newValue)
    }
  }
}
</script>

<style lang="scss">

.daterangepicker {
  margin-top: 15px;
  border-radius: 10px !important;
  font-family: Montserrat;
  font-weight: 500;

  .drp-buttons {
    .drp-selected {
      font-weight: 700;
    }

    .cancelBtn {
      border-radius: 4px !important;
      transition: .2s !important;
    }

    .applyBtn {
      background: #2F23D6;
      border: 1px solid #2F23D6;
      color: #FFFFFF;
      border-radius: 4px !important;
      transition: .2s !important;
      padding: 4px 28px;

      &:hover {
        background: #261CAB;
      }
    }
  }

  .calendar-table {
    .table-condensed {
      thead {

        tr {
          th {
            cursor: auto;
            font-weight: 600;
            min-width: 34px;
            width: 34px;
            max-width: 34px;
          }

          .next {
            cursor: pointer;
          }

          .prev {
            cursor: pointer;
          }

          .month {
            font-weight: 700;
          }
        }
      }

      tbody {
        tr {
          .start-date {
            border-top-left-radius: 8px !important;
            border-bottom-left-radius: 8px !important;
          }

          .end-date {
            border-top-right-radius: 8px !important;
            border-bottom-right-radius: 8px !important;
          }

          .active {
            background-color: #2F23D6 !important;

            &:hover {
              background-color: #271DB0 !important;
            }
          }

          .in-range {
            background-color: #2F23D642;
          }

          .available {
            &:hover {
              background-color: #2F23D61C;
            }
          }

          .off {
            background-color: #FFF !important;
          }
        }
      }
    }
  }
}

.datapicker-range {
  position: relative;

  label {
    font-size: 14px;
    font-weight: 400;
    color: #191919;
    margin-bottom: 4px;

    span {
      font-weight: 400;
      font-size: 14px;
      color: #FF445D;
    }
  }

  .datepicker-style {
    width: 100%;
    background: #EEF2F7;
    border-radius: 4px !important;
    padding: 6px 12px 6px 40px;
    border: 1px solid #EEF2F7;
    transition: .2s;
    cursor: pointer;

    font-size: 16px;
    font-weight: 400;
    color: #3A424E;

    &::placeholder {
      font-size: 16px;
      font-weight: 400;
      color: #3A424E;
    }

    &:hover {
      transition: .2s;
      border: 1px solid #CACACA;
    }

    &:focus-visible {
      outline: none;
      transition: .2s;
      border: 1px solid #CACACA;

      &::placeholder {
        transition: .1s;
        color: #EEF2F7;
      }
    }
  }

  svg {
    position: absolute;
    left: 23px;
    bottom: 7px;
    color: #111;
    pointer-events: none;
  }
}

</style>



// WEBPACK FOOTER //
// src/vue/pages/components/inputs/datapickerGlobal.vue